// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PaymentCardMaskedNumber_paymentCard_graphql = require("../../../__generated__/PaymentCardMaskedNumber_paymentCard_graphql.bs.js");

var convertFragment = PaymentCardMaskedNumber_paymentCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

var CardFragment_cardBrandV5_decode = PaymentCardMaskedNumber_paymentCard_graphql.Utils.cardBrandV5_decode;

var CardFragment_cardBrandV5_fromString = PaymentCardMaskedNumber_paymentCard_graphql.Utils.cardBrandV5_fromString;

var CardFragment = {
  cardBrandV5_decode: CardFragment_cardBrandV5_decode,
  cardBrandV5_fromString: CardFragment_cardBrandV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PaymentCardMaskedNumber(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var card = use(props.card);
  var match = card.brand;
  var maskedNumber;
  maskedNumber = match === "MASTERCARD" || match === "DISCOVER" || match === "AMERICAN_EXPRESS" || match === "VISA" ? (
      match === "AMERICAN_EXPRESS" ? "**** ****** *" + card.lastFour : "**** **** **** " + card.lastFour
    ) : "**** **** **** " + card.lastFour;
  return JsxRuntime.jsx("div", {
              children: maskedNumber,
              className: className
            });
}

var make = PaymentCardMaskedNumber;

exports.CardFragment = CardFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
